export default __webpack_public_path__ + "static/bg-b5c5f69d9e3082578398536e11007ecf.jpeg";